<script>
import Dollar from "@/assets/media/svg/icons/Shopping/Dollar.svg";
export default {
  name: "sales-roi",
  props: ["total_sales"],
  computed: {
    dollar() {
      return Dollar;
    }
  },
  methods: {
    formatNumber(value) {
      if (!value) return 0.00;
      return Number(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") ;
    },
    formatPercentage(value) {
      value = parseFloat(value).toFixed(2);
      return value + "%";
    }
  }
};
</script>

<template>
  <v-row>
    <v-col md="4">
      <v-card elevation="3">
        <div class="d-flex align-items-center flex-lg-fill">
          <div>
            <span class="symbol symbol-50 symbol-light-primary ml-5">
              <span class="symbol-label">
                <span class="svg-icon svg-icon-xl svg-icon-primary">
                  <inline-svg :src="dollar" />
                </span>
              </span>
            </span>
          </div>
          <div>
            <v-card-title class="text-h6">
              SALES
            </v-card-title>
            <v-card-subtitle class="text-h5 font-weight-bolder">
              <span class="color-purple">
                {{ formatNumber(total_sales.current_year) }}
              </span>
            </v-card-subtitle>
            <v-card-text class="mt-n3">
              <div>
                <strong class="text-danger">
                  {{ formatPercentage(total_sales.growth_rate) }}
                </strong>
                vs previous period
              </div>
            </v-card-text>
          </div>
        </div>
      </v-card>
    </v-col>
    <v-col md="4">
      <v-card elevation="3">
        <div class="d-flex align-items-center flex-lg-fill">
          <div>
            <span class="symbol symbol-50 symbol-light-success ml-5">
              <span class="symbol-label">
                <span class="svg-icon svg-icon-xl svg-icon-success">
                  <inline-svg :src="dollar" />
                </span>
              </span>
            </span>
          </div>
          <div>
            <v-card-title class="text-h6">
              REALIZED ROI
            </v-card-title>
            <v-card-subtitle class="text-h5 font-weight-bolder">
              <span class="color-green">
                N/A
              </span>
            </v-card-subtitle>
            <v-card-text class="mt-n3">
              <div>n/a</div>
            </v-card-text>
          </div>
        </div>
      </v-card>
    </v-col>
    <v-col md="4">
      <v-card elevation="3">
        <div class="d-flex align-items-center flex-lg-fill">
          <div>
            <span class="symbol symbol-50 symbol-light-danger ml-5">
              <span class="symbol-label">
                <span class="svg-icon svg-icon-xl svg-icon-danger">
                  <inline-svg :src="dollar" />
                </span>
              </span>
            </span>
          </div>
          <div>
            <v-card-title class="text-h6">
              MISSED ROI
            </v-card-title>
            <v-card-subtitle class="text-h5 font-weight-bolder">
              <span class="color-red">
                N/A
              </span>
            </v-card-subtitle>
            <v-card-text class="mt-n3">
              <div>n/a</div>
            </v-card-text>
          </div>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>
.color-purple {
  color: #5866db;
}
.color-green {
  color: green;
}
.color-red {
  color: red;
}
</style>
